import { render, staticRenderFns } from "./led_page_mng.vue?vue&type=template&id=4bc35c2e"
import script from "./led_page_mng.vue?vue&type=script&lang=js"
export * from "./led_page_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc35c2e')) {
      api.createRecord('4bc35c2e', component.options)
    } else {
      api.reload('4bc35c2e', component.options)
    }
    module.hot.accept("./led_page_mng.vue?vue&type=template&id=4bc35c2e", function () {
      api.rerender('4bc35c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/led/led_page_mng.vue"
export default component.exports